/** @jsxImportSource @emotion/react */
import React, { useEffect, useState, useCallback,useContext } from "react";
import { Grid, Typography, Tooltip, IconButton, DialogActions, Button, useMediaQuery, DialogContent, Snackbar, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import { withStyles, useTheme } from "@mui/styles";
import MuiDialogTitle from '@mui/material/DialogTitle';
import { useDropzone } from 'react-dropzone';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import PDFViewer from "../PDFViewer";
import { Il8nContext } from '../../Helper/i18n';


const classes = {
  root: {
    margin: 0,
    // padding: theme.spacing(2),
    height: '130px',
    display: 'flex'
  },
  center: {
      margin: 'auto',
      textAlign: 'center'
  },
  closeButton: {
    // right: theme.spacing(2),
    marginTop: '5px',
    color: '#F54040',
    background: '#F4F4F4'
  },
  actions: {
    flexDirection: 'row',
    display: 'flex',
  },
  deleteImageDiv: {
    width: '25px',
    height: '25px',
    background: '#000',
    opacity: 0.8,
    borderRadius: '50%',
    marginLeft: '42px',
    marginTop: '4px'
},
deleteImage: {
    marginLeft: '1px',
    marginTop: '3px',
    width: '13px'
}
}

const DialogTitle = /* withStyles(styles) */(props => {
  const { handleClose, title } = props;
  const localeText = useContext(Il8nContext)

    return (
      <MuiDialogTitle className={classes.root}>
        <Grid container>
                <Grid item md={4}>
                </Grid>
                <Grid item md={4} className={classes.center}>
                    <Typography variant="h5">{title || localeText?.uploadUploadPdf}</Typography>
                </Grid>
                <Grid item md={4}  className={classes.center} style={{textAlign: 'right'}}>
                    <Tooltip title="Close" aria-label="close">
                        <IconButton
                          aria-label="close"
                          className={classes.closeButton}
                          onClick={handleClose}
                          size="large">
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
      </MuiDialogTitle>
    );
});

function UploadPdf ({file,pdfName, handleClose,title, ...props}) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg')); 

  const [numPages, setNumPages] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [base64, setBase64] = useState()
  const [name, setName] = useState(null);
  const [showError, setShowError] = useState(false);
  const [pageNumber, setPageNumber] = useState(null);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [responseStatus, setResponseStatus] = useState({})
  const localeText = useContext(Il8nContext)

  

  //const [{numPages,pdf,name,showError},setState] = useState({numPages: null, pdf: null, name: null, showError: false})
  useEffect(() => {
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
    
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
    
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
    
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
    
      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
    let b64Data = file.split(',')[1];
    let blob = b64toBlob(b64Data, "application/pdf");
    let blobUrl = URL.createObjectURL(blob);
    setBase64(file);
    setPdf(blobUrl);
    setName(pdfName);
  }, [file, pdfName])

  const  onDrop = useCallback(acceptedFiles => {
    let reader=new FileReader();
    let promise = new Promise((res, rej) => {
      reader.onload = (readBytes) => {
        // if (acceptedFiles[0].size / (1024 * 1024) > 8) {
        //   setResponseStatus({ "message": "Please upload valid proof", "type": "error" })
        //   setSnackBarOpen(true)
        // } else {
          setPdf(readBytes.currentTarget.result);
          setName(acceptedFiles[0].name);
        //}
      }})
      reader.readAsDataURL(acceptedFiles[0]) 
  }, [pdf])
  const {getRootProps, getInputProps} = useDropzone({onDrop})

  function handleSnackBarClose(event, reason) {
    setSnackBarOpen(false)
    setResponseStatus()
  }

  return <>
      <DialogTitle handleClose={() => handleClose(pdf, name)} title={title}/>
      <DialogContent 
        style={{
            width: /* matches? */"100%"/* :"858px" */,
            height: matches?"50%":"100%",
            display: "flex",
            justifyContent: "center",
            padding:"0px"
        }}>
          {showError ? <div style={{fontWeight: 600, fontSize: '18px'}}>{localeText?.uploadRemovePasswbeforePdf}</div> : 
            <PDFViewer pdfFile={pdf} />
          }
      </DialogContent>
      <DialogActions style={{height: '150px', padding: '8px 50px'}}>
          <Grid container spacing={2}>
              <Grid item md={12} xs={12} className={`${classes.center} ${classes.actions}`} style={pdf == null && !showError ? {justifyContent: 'space-between'} : {justifyContent: 'flex-end'}}>
                {
                  pdf == null && !showError ? 
                  <div {...getRootProps()} style={{margin:"auto", width: '70px', height: '70px'}}>
                      <input {...getInputProps()} accept={".pdf"}/>
                      <img style={{cursor:"pointer"}} src={"images/add_icon.svg"} width={"70px"}  height={"70px"} alt=""/>
                  </div>:
                  null
                }
                {!props.noButtons ? <div style={{display: 'flex', alignItems: 'center', textAlign: 'right'}}>
                  <Button
                    variant="contained"
                    style={{width: '134px',marginRight:'5px'}}
                    onClick={()=> {
                        setPdf(null);
                        setName(null);
                        setBase64(null);
                      }}
                    disabled={pdf == null || showError}>
                      {localeText?.uploadRemoveBtn}
                  </Button>
                  <Button color="primary" variant="contained" style={{width: '134px'}} onClick={()=>props.onUpload(base64, name)} disabled={pdf == null || showError}>
                      {localeText?.uploadBtn}
                  </Button> </div>: <></>}
                
              </Grid>
          </Grid>
      </DialogActions>
      {
        responseStatus && responseStatus.message &&
        <Snackbar
            anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
            }}
            open={snackBarOpen}
            autoHideDuration={5000}
            onClose={handleSnackBarClose}
        >
            <MySnackbarContentWrapper
            onClose={handleSnackBarClose}
            variant={responseStatus.type}
            message={responseStatus.message}
            />
        </Snackbar>
      }
  </>;
}

export default /* withStyles(styles) */(UploadPdf)